import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEdit, faTrashAlt, faSpinner, faPrint, faDownload } from '@fortawesome/free-solid-svg-icons';
import './ActionButtons.css';

/**
 * Reusable ActionButtons component that matches the exact "old stack" design.
 * 
 * @param {Object} props
 * @param {Function} props.onView - Function to call on View click
 * @param {Function} props.onPrint - Function to call on Print click
 * @param {Function} props.onDownload - Function to call on Download click
 * @param {Function} props.onEdit - Function to call on Edit click
 * @param {Function} props.onDelete - Function to call on Delete click
 * @param {boolean} props.isDeleting - Whether the delete action is in progress
 * @param {boolean} props.isPrinting - Whether the print action is in progress
 * @param {boolean} props.isDownloading - Whether the download action is in progress
 * @param {boolean} props.hideView - (Optional) hide the view button
 * @param {boolean} props.hidePrint - (Optional) hide the print button
 * @param {boolean} props.hideDownload - (Optional) hide the download button
 * @param {boolean} props.hideEdit - (Optional) hide the edit button
 * @param {boolean} props.hideDelete - (Optional) hide the delete button
 */
const ActionButtons = ({
  onView,
  onPrint,
  onDownload,
  onEdit,
  onDelete,
  isDeleting = false,
  isPrinting = false,
  isDownloading = false,
  hideView = false,
  hidePrint = false,
  hideDownload = false,
  hideEdit = false,
  hideDelete = false,
  extraButtons = null
}) => {
  return (
    <div className="res-action-buttons-container">
      {!hideView && onView && (
        <button
          type="button"
          className="res-action-btn res-view-btn"
          onClick={onView}
          title="View"
        >
          <FontAwesomeIcon icon={faEye} />
        </button>
      )}

      {!hidePrint && onPrint && (
        <button
          type="button"
          className="res-action-btn res-print-btn"
          onClick={onPrint}
          title="Print"
          disabled={isPrinting}
        >
          {isPrinting ? (
            <FontAwesomeIcon icon={faSpinner} spin />
          ) : (
            <FontAwesomeIcon icon={faPrint} />
          )}
        </button>
      )}

      {!hideDownload && onDownload && (
        <button
          type="button"
          className="res-action-btn res-download-btn"
          onClick={onDownload}
          title="Download"
          disabled={isDownloading}
        >
          {isDownloading ? (
            <FontAwesomeIcon icon={faSpinner} spin />
          ) : (
            <FontAwesomeIcon icon={faDownload} />
          )}
        </button>
      )}

      {!hideEdit && onEdit && (
        <button
          type="button"
          className="res-action-btn res-edit-btn"
          onClick={onEdit}
          title="Edit"
        >
          <FontAwesomeIcon icon={faEdit} />
        </button>
      )}

      {!hideDelete && onDelete && (
        <button
          type="button"
          className="res-action-btn res-delete-btn"
          onClick={onDelete}
          title="Delete"
          disabled={isDeleting}
        >
          {isDeleting ? (
            <FontAwesomeIcon icon={faSpinner} spin />
          ) : (
            <FontAwesomeIcon icon={faTrashAlt} />
          )}
        </button>
      )}

      {typeof extraButtons === 'function' ? extraButtons() : extraButtons}
    </div>
  );
};

export default ActionButtons;
